import {MoveMaterial, MaterialOutput} from "@cm/template-nodes"
import type {MaterialLikeNode, NumberLike} from "@cm/template-nodes"
import {createMaterialInput, createMaterialExport, createNumberInput, createMathOperator} from "#mattress/assets-definitions/common"
import {MattressComponentGraph} from "#mattress/nodes/component/mattress-component-graph"
import {MattressComponentInstance} from "#mattress/nodes/component/mattress-component-instance"
import {MattressNodes} from "#mattress/nodes/mattress-nodes"

export function getNodesForTopAndBottomPartMaterialOffsetUtilityTemplate() {
    const material = createMaterialInput("Material", "material")
    const width = createNumberInput("Width", "width", 0)
    const height = createNumberInput("Height", "height", 0)
    const length = createNumberInput("Length", "length", 0)
    const edgeRadius = createNumberInput("Edge Radius", "edgeRadius", 0)

    const halfWidth = createMathOperator("Width / 2", "div", width, 2)
    const halfLength = createMathOperator("Height / 2", "div", length, 2)
    const piHalf = createMathOperator("Pi / 2", "div", Math.PI, 2)
    const c1 = createMathOperator("Pi / 2 - 2", "sub", piHalf, 2)
    const c2 = createMathOperator("(Pi / 2 - 2) * Edge Radius", "mul", c1, edgeRadius)
    const c3 = createMathOperator("(Pi / 2 - 2) * Edge Radius + Height", "add", c2, height)

    const offsetU = createMathOperator("Offset U", "add", c3, halfLength)
    const offsetV = createMathOperator("Offset V", "add", c3, halfWidth)

    const materialOffset = new MoveMaterial({
        parameters: {
            name: "Material Offset",
            material,
            horizontalOffset: offsetU,
            verticalOffset: offsetV,
        },
    })
    const materialOffsetExport = createMaterialExport("Material Offset", "material-offset", materialOffset)

    return [material, width, height, length, edgeRadius, halfWidth, halfLength, piHalf, c1, c2, c3, offsetU, offsetV, materialOffset, materialOffsetExport]
}

export function getComponentGraphForTopAndBottomPartMaterialOffsetUtilityTemplate() {
    return new MattressComponentGraph({
        parameters: {
            name: "Top and Bottom Panel Material Offset Utility",
            nodes: new MattressNodes({parameters: {list: [...getNodesForTopAndBottomPartMaterialOffsetUtilityTemplate()]}}),
        },
    })
}

export function getComponentInstanceAndOutputForTopAndBottomPartMaterialOffsetUtilityTemplate(inputData: {
    componentGraph: MattressComponentGraph
    componentInstanceName: string
    componentInstanceId: string
    outputName: string
    material: MaterialLikeNode
    width: NumberLike
    length: NumberLike
    heigth: NumberLike
    edgeRadius: NumberLike
}) {
    const materialOffsetComponentInstance = new MattressComponentInstance({
        parameters: {
            name: inputData.componentInstanceName,
            id: inputData.componentInstanceId,
            graph: inputData.componentGraph,
            parameters: {
                material: inputData.material,
                width: inputData.width,
                length: inputData.length,
                height: inputData.heigth,
                edgeRadius: inputData.edgeRadius,
            },
        },
    })

    const materialOffsetOutput = materialOffsetComponentInstance.createOutput("material-offset", {
        source: "template",
        outputNodeClass: MaterialOutput,
        name: inputData.outputName,
    })
    if (!(materialOffsetOutput instanceof MaterialOutput)) throw new Error("Expected output to be instance of MaterialOutput")

    return {materialOffsetComponentInstance, materialOffsetOutput}
}
